export default {
  'NavigationBar.Buttons.Next': ({newTab }, stateManager) => {
    stateManager.setSelectedTabId(newTab)
  },
  'NavigationBar.Buttons.Previous': ({newTab }, stateManager) => {
    stateManager.setSelectedTabId(newTab)
  },
}
